import React, { useEffect } from 'react';
import {
    Divider,
    Header,
    Menu,
    Segment,
} from 'semantic-ui-react';

const DonationIncentives = ({ donationValue, incentives, incentive, setIncentive }) => {
    useEffect(() => {
        const selected = incentives.filter((obj) => {
            return obj.key === incentive
        });

        if (selected.length === 1) {
            if (selected[0].min > donationValue) {
                setIncentive(null);
            }
        }
    }, [donationValue, incentive, incentives, setIncentive]);

    const availableIncentives = incentives.filter((obj) => {
        return obj.minimum <= donationValue
    });

    const groups = [...new Set(incentives.map(item => item.minimum))].filter((x) => {
        return x > donationValue;
    });

    const remainingIncentives = Array.from(groups, x => incentives.filter((rewards) => {
        return rewards.minimum === x
    }));

    return (
        <Segment>
            <Header>Incentives:</Header>
            {availableIncentives.length > 0 ?
                <Menu vertical fluid>
                    {Object.entries(availableIncentives).map(([key, value], i) =>
                        <Menu.Item active={incentive === value.id} onClick={(ev, data) => setIncentive(data['data-reward-id'])} data-reward-id={value.id}>{value.description}</Menu.Item>
                    )}
                </Menu>
                : 'No incentives available yet! Select a donation amount first.'}
            {remainingIncentives.length > 0 ?
                remainingIncentives.map(group =>
                    <React.Fragment>
                        <Divider horizontal>
                            <Header as='h4'>
                                Donate ${parseInt(group[0].minimum, 10)} or more to be able to:
                            </Header>
                        </Divider>
                        <Menu vertical fluid style={{ 'maxHeight': '210px', 'overflow': 'auto' }}>
                            {Object.entries(group).map(([key, value], i) =>
                                <Menu.Item disabled>{value.description}</Menu.Item>
                            )}
                        </Menu>
                    </React.Fragment>
                )
                : ''}

        </Segment>
    )
}

export default DonationIncentives;
